import { SectionTitle } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import background from './assets/shiba.webp';
import * as Styled from './styled';
import type { LoginPageProps } from './types';

export * from './types';

export const LoginPage: FC<LoginPageProps> = (props) => {
  const { formComponent } = props;
  const { translate } = useTranslation();

  return (
    <Styled.Wrapper>
      <Styled.BackgroundWrapper>
        <Styled.Background src={background} />
      </Styled.BackgroundWrapper>
      <Styled.MainWrapper>
        <Styled.Main>
          <SectionTitle>{translate('login.title')}</SectionTitle>
          {formComponent}
        </Styled.Main>
      </Styled.MainWrapper>
    </Styled.Wrapper>
  );
};
